import "./styles.css";

import React, { useState } from "react";
import { toast } from "react-toastify";
import Popup from "reactjs-popup";

import checkicon from "../../../../assets/icons/check.svg";
import closeIcon from "../../../../assets/icons/icons-close.svg";
import downloadIcon from "../../../../assets/images/downloadIcon.svg";
import { useExcelExport } from "../../../../lib/queries/queriesAndMutations";
import { convertPersianToEnglishNumber } from "../../../../utils/utils";

const ExcelPopupBtn = ({ searchTermRef, url, fields, type, businessId }) => {
  const [formData, setFormData] = useState(
    fields.reduce((acc, item) => {
      acc[item.value] = false;
      return acc;
    }, {}),
  );

  const { mutateAsync: excelExport } = useExcelExport();

  const handleChange = ({ name, checked }) => {
    if (name === "all") {
      setFormData((prev) => {
        const updatedFormData = Object.keys(prev).reduce((acc, key) => {
          acc[key] = checked;
          return acc;
        }, {});
        return updatedFormData;
      });
    } else {
      setFormData((prev) => ({
        ...prev,
        [name]: checked,
      }));
    }
  };

  const handleButtonClick = async ({ handleClose }) => {
    const { all, ...rest } = formData;
    const data = Object.keys(rest).filter((key) => rest[key]);
    const debounce = {
      ...searchTermRef,
      ...[
        "from_amount",
        "to_amount",
        "exact_amount",
        "reference_number",
        "card_number",
        "track_id",
        "vanda_tracking_code",
      ].reduce((acc, key) => {
        if (searchTermRef?.[key]) {
          acc[key] = convertPersianToEnglishNumber(searchTermRef[key]);
        } else {
          acc[key] = "";
        }
        return acc;
      }, {}),
      form_id:
        searchTermRef?.form_id && typeof searchTermRef.form_id === "object" ? searchTermRef.form_id.id : "",
      gateway_id:
        searchTermRef?.gateway_id && typeof searchTermRef.gateway_id === "object"
          ? searchTermRef.gateway_id.id
          : "",
    };

    try {
      ////console.log({searchTermRef})
      const res = await excelExport({
        data,
        searchTermRef: debounce,
        url,
        type,
        businessId,
      });
      ////console.log(res.data,"excelecport")
      if (res?.status === 200) {
        toast.success("درخواست شما با موفقیت ثبت شد. می‌توانید خروجی اکسل را در منوی خروجی‌ها مشاهده کنید.");
        //window.open(res.data.url);
        handleClose();
      }
    } catch (error) {
      console.error("excelExport", error);
    }
  };

  return (
    <Popup
      trigger={
        <div className="cursor-pointer flex justify-center items-center px-2 py-2 rounded-v-lg bg-neutral-20 gap-2">
          <p>اکسل</p>
          <img className="w-5 h-5" src={downloadIcon} alt="download" />
        </div>
      }
      modal
      nested
    >
      {(close) => (
        <div className="w-full bg-neutral-10 mb-5 rounded-v-lg p-4 flex flex-col" dir="rtl">
          <div className="flex-between p-2 ">
            <p lassName="text-title-3xl-regular" c>
              فیلد های اکسل
            </p>
            <button onClick={close}>
              <img className="cursor-pointer" src={closeIcon} alt="close-icon" width={24} height={24} />
            </button>
          </div>
          <hr />
          <div className="grid grid-cols-1  md:grid-cols-4 gap-2 overflow-y-scroll vanda md:no-scrollbar max-h-[50vh] ">
            {fields.map((item, index) => (
              <div key={index} className="flex items-center gap-2 mt-4 col-span-1">
                {/* Custom checkbox */}
                <label
                  className="relative flex items-center justify-center cursor-pointer"
                  style={{
                    width: 20,
                    height: 20,
                    border: "2px solid black",
                    borderRadius: 4,
                  }}
                >
                  <input
                    type="checkbox"
                    name={item.value}
                    checked={!!formData[item.value]}
                    onChange={(e) =>
                      handleChange({
                        name: item.value,
                        checked: e.target.checked,
                      })
                    }
                    className="absolute opacity-0 w-full h-full cursor-pointer"
                  />

                  {/* Check icon */}
                  {formData[item.value] && (
                    <div className="flex items-center justify-center w-full h-full bg-black">
                      <img src={checkicon} alt="check-icon" width={14} height={14} />
                    </div>
                  )}
                </label>

                {/* Label text */}
                <label title={item.label} className="cursor-pointer">
                  {item.label}
                </label>
              </div>
            ))}
          </div>
          <button
            className=" mr-auto mt-4 px-4 py-2 bg-dark hover:bg-slate-600 text-white rounded "
            onClick={() => handleButtonClick({ handleClose: () => close() })}
          >
            اکسل خروجی
          </button>

          <p className="bg-secondary-10 my-4 text-secondary-80 max-w-[80vw]">
            بدون تعریف فیلتر، خروجی اکسل فقط شامل تراکنش‌های امروز می‌باشد. برای دریافت خروجی در بازه‌ی
            دلخواه، از جستجوی پیشرفته استفاده کنید.
          </p>
        </div>
      )}
    </Popup>
  );
};

export default ExcelPopupBtn;
